function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.823 1.52219L20.2932 14.838C20.4576 15.2354 20.5295 15.5586 20.5501 15.8944C20.5912 16.6788 20.324 17.4413 19.8 18.0281C19.2759 18.6128 18.5669 18.9579 17.7963 18.9998H2.75314C2.4346 18.9799 2.11606 18.9056 1.81808 18.7906C0.328149 18.1735 -0.391126 16.4372 0.21512 14.9321L7.73669 1.51277C7.99357 1.04106 8.38404 0.634189 8.86698 0.372705C10.2644 -0.423251 12.0421 0.0997165 12.823 1.52219ZM11.1686 10.2976C11.1686 10.7996 10.7679 11.219 10.2747 11.219C9.78144 11.219 9.37042 10.7996 9.37042 10.2976V7.33861C9.37042 6.83552 9.78144 6.42865 10.2747 6.42865C10.7679 6.42865 11.1686 6.83552 11.1686 7.33861V10.2976ZM10.2747 14.7962C9.78144 14.7962 9.37042 14.3768 9.37042 13.8758C9.37042 13.3727 9.78144 12.9543 10.2747 12.9543C10.7679 12.9543 11.1686 13.3633 11.1686 13.8643C11.1686 14.3768 10.7679 14.7962 10.2747 14.7962Z",
  fill: "#FF2E53"
});

function SvgCriticalSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalSmall);
export default __webpack_public_path__ + "static/media/critical-small.1c38b7a0.svg";
export { ForwardRef as ReactComponent };